import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {};

const enhance = compose();

const tableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopId'}
            direction={order}
            onClick={() => {
              onRequestSort('shopId');
            }}
          >
            店舗ID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('shopRegister');
            }}
          >
            店舗情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('menuRegister');
            }}
          >
            メニュー情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'identityRegister' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'identityRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('identityRegister');
            }}
          >
            本人確認情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'stripeRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'stripeRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('stripeRegister');
            }}
          >
            Stripe情報登録
            <br />
            （自社で入金管理）
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'bankRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'bankRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('bankRegister');
            }}
          >
            銀行口座情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
